import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const usePrepareOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) => {
    updateOrder(data, OrderStatus.preparing);
  };

  return useApiMutation({
    url: `/orders/${orderId}/preparing`,
    method: 'PATCH',
    errorTitle: 'Erro ao preparar pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido em preparo!',
    onSuccess,
  });
};

export default usePrepareOrder;
